import * as Yup from 'yup';
import {LectureFormValues} from './types';

export const initialValueLecture: LectureFormValues = {
    title: '',
    lecturerIds: [],
    thid: null,
    tsid: null,
    dayIndex: 0,
    description: '',
    amount: 0,
    price: 0,
    hasCasualPrice: false,
    priceCasual: 0,
    isRequired: false,
    link: '',
};

export const buildValidationSchema = (requiredMessage: string) =>
    Yup.object({
        title: Yup.string().required(requiredMessage),
        tsid: Yup.number().nullable().required(requiredMessage),
        dayIndex: Yup.number().min(0, requiredMessage).required(requiredMessage),
        amount: Yup.number().min(0),
        price: Yup.number().min(0),
    });
